import Factory from './utils/factory'

const FlatfinderItem = Factory({
  data: {
    geometry: null,
    type: null,
    description: null,
    redirectUrl: null,
    thumbnailType: 'cover'
  },
  reference: null
})

export default Factory({
  id: null,
  name: null,
  image: null,
  parent: null,
  isEntry: false,
  items: [FlatfinderItem],
})
